import { gql } from '@apollo/client';

export const fetchUserHistoryForEntitlementQuery = gql`
  query fetchUserHistoryForEntitlement($id: String, $filterOptions: [FilterOption]) {
    entitlementDetails(id: $id) {
      id
      subscriptionId
      edition
      userHistory(filterOptions: $filterOptions) {
        results {
          chargeElement
          quantity
          usersUpdate {
            isCreated
            isAdded
            isRemoved
            changeBy
          }
          lastUpdatedAt
        }
        nextId
      }
    }
  }
`;
